<template>
    <div
        class="toggle-container"
        @click="toggleModelValue"
        :class="modelValue ? backgroundColor : null"
    >
        <div class="toggle-eye" :class="{ active: modelValue }"></div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        backgroundColor: {
            type: String,
            required: false,
            default: "orange",
        },
    },

    emits: ["update:modelValue"],

    methods: {
        toggleModelValue() {
            this.$emit("update:modelValue", !this.modelValue)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

.toggle-container {
    width: 60px;
    height: 30px;
    border-radius: 99px;
    position: relative;
    display: flex;
    align-items: center;
    transition: all 0.2s ease-in-out;
    background-color: $light-grey;
    box-shadow: inset 1px 1px 4px 0px rgba($black, $alpha: 0.2);

    .toggle-eye {
        width: 25px;
        height: 25px;
        border-radius: 99px;
        background: $white;
        position: absolute;
        box-shadow: 1px 1px 4px 0px rgba($black, $alpha: 0.5);
        left: 5%;

        transition: all 0.2s ease-in-out;

        &.active {
            left: calc(100% - 5% - 25px);
        }
    }

    &:hover {
        cursor: pointer;
    }

    &.orange {
        background-color: $orange-neutral;
    }
}
</style>
